import { PartnerSignUpTemplate } from '@/components/template/PartnerSignUpTemplate/PartnerSignUpTemplate';

const PartnerSignUpPage = () => {
  return <PartnerSignUpTemplate />;
};

export default PartnerSignUpPage;
